import { Box, IconButton, IconName } from '@talos/kyoko';

type FavoritesToggleButtonProps = {
  isActive: boolean;
  onToggle: () => void;
};

export const FavoritesToggleButton = ({ isActive, onToggle }: FavoritesToggleButtonProps) => (
  <Box ml="-spacing4">
    <IconButton
      ghost
      onClick={onToggle}
      icon={isActive ? IconName.StarSolid : IconName.Star}
      color={isActive ? 'yellow.lighten' : 'gray.080'}
      className="toggle-favorites"
      data-testid="toggle-favorites"
    />
  </Box>
);
